import React from 'react';
import { Link } from 'react-router-dom';
import { colors, spacing, typographyFlat } from '../../styles/tokens';
import { inventoryCopyLookupHref, type InventoryCopyLookupTarget } from '../../lib/inventoryNav';

/**
 * "Open in Lookup" for a copy whose product_line maps to Magic, Pokémon, or Lorcana.
 * Renders nothing when the line is unknown so mixed rows without a game stay put.
 */
export const InventoryCopyLookupLink: React.FC<InventoryCopyLookupTarget> = (target) => {
  const href = inventoryCopyLookupHref(target);
  if (!href) return null;
  const name = target.productName?.trim() || 'this copy';
  return (
    <Link to={href} style={styles.link}>
      Open {name} in Lookup
    </Link>
  );
};

const styles = {
  link: {
    color: colors.primary,
    fontSize: typographyFlat.fontSize.sm,
    fontWeight: typographyFlat.fontWeight.medium,
    textDecoration: 'none',
    display: 'inline-block',
    marginTop: spacing.xs,
  },
};
